import { CLAIMS_ENUM, isUsersHighestClaimOneOf } from '../../helpers/utils';
import store from '../store';

export const resolveUsersRoomsOrLocations = (userStore, desiredUserPropKey, organizationId?) => {
  const { claims } = userStore;
  const targetClaims = [CLAIMS_ENUM.teacher, CLAIMS_ENUM.supportStaff];

  const isScoped = isUsersHighestClaimOneOf(claims, targetClaims);
  if (isScoped) {
    // Root and organization user documents hydrate independently. Do not start
    // a scoped listener until the org profile has arrived for the selected org.
    // Also defer when organizationId is absent — the initial-start effect can
    // call here with a transiently falsy org during an org switch before the
    // re-subscribe effect's own !organizationId guard fires.
    if (!organizationId || userStore.defaultOrganization !== organizationId) {
      return null;
    }

    const userPropValue = userStore[desiredUserPropKey];
    if (!userPropValue || typeof userPropValue !== 'object') {
      return ['-1']; // a fake room id to make sure we don't elevate permissions for users without rooms or locations
    }
    const results = Object.keys(userPropValue);
    return results.length > 0 ? results : ['-1']; // a fake room id to make sure we don't elevate permissions for users without rooms or locations
  }

  return [];
};

export const getUsersRoomsOrLocations = (desiredUserPropKey, organizationId?) => {
  const userStore = store.getState()?.user || {};
  return resolveUsersRoomsOrLocations(userStore, desiredUserPropKey, organizationId);
};
